import React, { useCallback } from 'react';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import { useInfiniteScroll } from 'hooks';

import { HistoryChatsListItem } from '../HistoryChatsListItem';

import { useHistoryChatsStyles } from './HistoryChats.styled';

export const HistoryChats = ({
  hasMoreConversations = false,
  historyChats = [],
  isLoadingMoreConversations = false,
  onClickConversation,
  onDeleteConversation,
  onFetchMore,
  onPinConversation,
  onRenameConversation,
  selectedChatId
}) => {
  const handleScrollEndTrigger = useCallback(() => {
    if (!hasMoreConversations || isLoadingMoreConversations || !onFetchMore) return;
    onFetchMore();
  }, [hasMoreConversations, isLoadingMoreConversations, onFetchMore]);

  const { listEndRef } = useInfiniteScroll({
    onScrollEndTrigger: handleScrollEndTrigger
  });
  const classes = useHistoryChatsStyles();

  const sortedChats = [...historyChats].sort((a, b) => {
    if (a.isPinned === b.isPinned) return 0;
    return a.isPinned ? -1 : 1;
  });

  return (
    <Box className={classes.listSection}>
      <List disablePadding>
        {sortedChats.map(chat => (
          <HistoryChatsListItem
            key={chat.sessionId}
            chat={chat}
            isSelected={selectedChatId === chat.sessionId}
            onClick={chatId => onClickConversation && onClickConversation(chatId)}
            onDelete={onDeleteConversation}
            onPin={onPinConversation}
            onRename={onRenameConversation}
          />
        ))}
      </List>

      <div ref={listEndRef} />
    </Box>
  );
};
